import { createFileRoute } from '@tanstack/react-router'
import { StorybookShowcase } from '@/storybook/storybook-showcase'

export const Route = createFileRoute('/demo/storybook')({
  component: StorybookPreviewRoute,
})

function StorybookPreviewRoute() {
  return <StorybookShowcase />
}
